import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false
})
export class CapitalizePipe implements PipeTransform {

    transform(value: string, allWords: boolean = false): string {
        if (!value) return value;

        if (allWords) {
            return value.replace(/\b\w/g, first => first.toLocaleUpperCase());
        } else {
            return value.toLowerCase().replace(/(^\w)|([.]\s*\w)/g, match => {
                if (match.includes('.')) {
                    return match.replace(/\w$/, letter => letter.toUpperCase());
                }
                return match.toUpperCase();
            });
        }
    }
}
